import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import T from 'i18n-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AccountStore from '../../store/Account';
import * as CommonStore from '../../store/Common';
import ConfirmModal from '../shared/ConfirmModal';
import LoadingButton from '../shared/LoadingButton';
import LoadingOverlay from '../shared/LoadingOverlay';
import MessageError from '../shared/MessageError';


const Scroll = require('react-scroll');

const initialState = {
    activeTab: '1',
    fields: [
        { name: 'lowThreshold', isRequired: true, minValue: 20, maxValue: 100 },
        { name: 'highThreshold', isRequired: true, minValue: 20, maxValue: 100 },
        { rollingAverage: null },
        // Removed rolloverDays field
    ],
    selectedSerialNumber: 0
};

const INFO_MESSAGE_CONTENT = [
    "intro",
    "howItWorks",
    "definition",
    "lowExample",
    "highExample",
    "averageDailyUsageNote",
    "thresholdRange",
    "note",
];

class Threshold extends Component {

    constructor(props) {
        super(props);

        this.state = initialState;
    }

    componentWillMount() {
        Scroll.animateScroll.scrollToTop({ smooth: true, duration: 500 });
        document.title = T.translate('common.client') + ' | ' + T.translate('threshold.title');

        if (this.props.account.accountNumber) {
            this.props.thresholdMeterList();

            if (this.props.accountMeterList.length > 1) {
                this.setState({ selectedSerialNumber: this.props.accountMeterList[0].meterSerialNumber });
                this.props.thresholdInit(this.state.selectedSerialNumber);
                this.props.fetchRollingAverage(this.state.selectedSerialNumber);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        //when user refresh the browser - once we get the account - get screen data

        if ((nextProps.account.accountNumber && !this.props.account.accountNumber) || nextProps.account.accountNumber !== this.props.account.accountNumber) {

            this.props.thresholdMeterList();

            if (this.props.accountMeterList.length > 1) {
                this.setState({ selectedSerialNumber: this.props.accountMeterList[0].meterSerialNumber });
                this.props.thresholdInit(this.props.accountMeterList[0].meterSerialNumber);
                this.props.fetchRollingAverage(this.props.accountMeterList[0].meterSerialNumber);
            }
            else {
                this.setState({ selectedSerialNumber: 0 });
            }

        }
    }

    toggleActiveTab = (e) => {
        // Prevents page redirection
        e.preventDefault();
        var tab = e.target.attributes['data-tab'].value;
        this.setState({ activeTab: tab });
    }

    onChangeMeter = (e) => {
        let state = this.state;
        state.selectedSerialNumber = e.target.value;

        if (e.target.value) {

            this.setState({ selectedSerialNumber: e.target.value });
            this.props.thresholdInit(state.selectedSerialNumber);
            this.props.fetchRollingAverage(this.props.accountMeterList[0].meterSerialNumber);
        }
        else {
            this.setState({ selectedSerialNumber: 0 });
            this.setState({ rollingAverage: null });
        }
    }

    onChangeLow = (e) => {

        let val = this.convertNumberValue(e.target.value);

        let hasError = this.checkValue(val, "lowTreshold");

        this.props.setThresholdValue(this.props.thresholdDetails, "lowTreshold", val);

        if (!hasError) {
            this.props.setAccountError('');
        }
        else {
            this.props.thresholdError(hasError)
        }
    }

    onChangeHigh = (e) => {

        let val = this.convertNumberValue(e.target.value);

        let hasError = this.checkValue(val, "thresholdHigh");

        this.props.setThresholdValue(this.props.thresholdDetails, "thresholdHigh", val);

        if (!hasError) {
            this.props.setAccountError('');
        }
        else {
            this.props.thresholdError(hasError)
        }

    }

    //onChangeRolloverDays = (e) => {

    //    let val = this.convertNumberValue(e.target.value);

    //    let hasError = this.checkValue(val, "rolloverDays");

    //    this.props.setThresholdValue(this.props.thresholdDetails, "rolloverDays", val);

    //    if (!hasError) {
    //        this.props.setAccountError('');
    //    }
    //    else {
    //        this.props.thresholdError(hasError)
    //    }
    //}

    convertNumberValue = (text) => {
        const num = Number(text);
        return isNaN(num) ? 0 : num;
    }

    checkValue = (val, valueType, fromSubmit) => {
        switch (valueType) {
            // Removed rolloverDays validation

            case "lowThreshold":
                if (val < 20) {
                    return T.translate('threshold.minimumLowThreshold');
                }
                if (val > 100) {
                    return T.translate('threshold.maximumLowThreshold');
                }
                if (val > this.props.thresholdDetails.thresholdHigh && fromSubmit) {
                    return T.translate('threshold.minimumGreaterHighThreshold');
                }
                break;

            case "thresholdHigh":
                if (val < 20) {
                    return T.translate('threshold.minimumHighThreshold');
                }
                if (val > 100) {
                    return T.translate('threshold.maximumHighThreshold');
                }
                if (val < this.props.thresholdDetails.thresholdLow && fromSubmit) {
                    return T.translate('threshold.maximumLessLowThreshold');
                }
                break;
        }
        return "";
    }

    onSubmit = (e) => {

        let state = this.state;

        let thresholdData = {
            serialNumber: state.selectedSerialNumber,
            thresholdClusterID: this.props.thresholdDetails.thresholdClusterID,
            value: {
                lowThreshold: this.props.thresholdDetails.thresholdLow,
                highThreshold: this.props.thresholdDetails.thresholdHigh,
                notifyUser: 1
            }
        }

        //Check value before submit

        let hasErrorLow = this.checkValue(this.props.thresholdDetails.thresholdLow, "lowThreshold", true);
        let hasErrorHigh = this.checkValue(this.props.thresholdDetails.thresholdHigh, "thresholdHigh", true);

        if (hasErrorLow || hasErrorHigh) {

            if (hasErrorLow) {
                this.props.thresholdError(hasErrorLow)
            }

            if (hasErrorHigh) {
                this.props.thresholdError(hasErrorHigh)
            }


            return;
        }
        else {
            this.props.setAccountError('');
        }

        this.props.saveThreshold(thresholdData);
    }

    onCancelClick = (e) => {
        // Prevents page redirection
        e.preventDefault();
        this.setState({ selectedSerialNumber: 0 });
        this.props.setAccountError('');
    }

    onChangeThreshold = (e) => {
        let val = e.target.value;
    }

    isWithinRange = (val, minVal, maxVal) => {

        if (val < minVal || val > maxVal) {
            return false;
        }

        return true;

    }

    isNumeric = (n) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    setHighlightStyle = (columnId) => {
        var styleClass = '';

        if (columnId === 'thresholdChannelName') {
            styleClass = 'plan-current kanit font-weight-normal';
        }

        return styleClass;
    }

    showHiLoInfo = (e) => {
        this.setState({ displayHiLoInfo: true });
    }

    hideHiLoInfo = (e) => {
        this.setState({ displayHiLoInfo: false });
    }

    render() {
        return (
            <div className="p-main">
                <LoadingOverlay loading={this.props.accountLoading} />

                <div className="page-header">
                    <div className="page-title">{T.translate('threshold.pageTitle')}</div>
                    <p className="lead text-dark font-weight-normal">
                        {T.translate('threshold.manageThresholdSubTitle')}
                    </p>
                </div>

                <MessageError>{this.props.ErrorMessage || this.props.accountErrorMessage}</MessageError>

                <div className="diverter" />
                <ul className="nav nav-tabs">
                    <li className="nav-item"><a className={"nav-link " + (this.state.activeTab === '1' ? "active" : "")} onClick={this.toggleActiveTab} data-tab="1" href="#">{T.translate('threshold.thresholdOffsets')}</a></li>
                </ul>
                <div className="tab-content mb-4">

                    {this.state.activeTab === '1' && <div className={"tab-pane " + (this.state.activeTab === '1' ? "active" : "")}>
                        <div className="row">
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="meterList">{T.translate('threshold.meter')}</label>
                                            <select className="form-control" name="meterList" id="meterList" value={this.state.selectedSerialNumber} onChange={this.onChangeMeter} >
                                                <option value="" selected>{T.translate("threshold.selectMeter")}</option>
                                                {
                                                    this.props.accountMeterList.map(function (meter) {
                                                        return <option key={meter.meterSerialNumber}
                                                            value={meter.meterSerialNumber}>
                                                            {meter.serviceTypeName} - {meter.meterSerialNumber} : {meter.meterTypeName}</option>;
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {this.state.selectedSerialNumber != 0 &&
                                    <>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                <label id="lbllowThreshold" htmlFor="lowThreshold">{T.translate('threshold.lowThreshold')}</label>
                                                <input type="number" id="lowThreshold" name="lowThreshold" value={this.props.thresholdDetails.thresholdLow || 20} onChange={this.onChangeLow} className="form-control" min="20" max="100" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="highThreshold">{T.translate('threshold.highThreshold')}</label>
                                                <input type="number" id="highThreshold" name="highThreshold" value={this.props.thresholdDetails.thresholdHigh || 20} onChange={this.onChangeHigh} className="form-control" min="20" max="100" />
                                                </div>
                                            </div>
                                        </div>
                                    </>}

                                {this.state.selectedSerialNumber != 0 &&
                                    <>
                                        <div className="diverter mt-0 mb-3" />
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <LoadingButton
                                                        className="btn btn-primary mr-3 px-4 py-2"
                                                        onClick={this.onSubmit}
                                                        loading={this.props.accountLoading ? 'true' : 'false'}>
                                                        {T.translate('threshold.save')}
                                                    </LoadingButton>
                                                    <a
                                                        href="#"
                                                        onClick={this.onCancelClick}
                                                        className="btn btn-outline-dark px-4 py-2">
                                                        {T.translate('common.cancel')}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>

                            <div className="col-md-4">

                                <div className="alert alert-info fade in show d-flex">
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="d-flex">
                                                    <FontAwesomeIcon className="mr-3" size="2x" icon={faInfoCircle} />
                                                    <p>
                                                        <p>{T.translate('threshold.infoTitle')}</p>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                {INFO_MESSAGE_CONTENT.map((contentKey, index) => (
                                                    <p key={index} className={`text-sm ${T.translate('threshold.' + contentKey).startsWith('-') ? 'ml-4' : ''} ${contentKey === 'howItWorks' ? 'font-medium mt-2' : ''}`}>
                                                        {T.translate(`threshold.${contentKey}`)}
                                                    </p>
                                                ))}
                                                {this.state.selectedSerialNumber != 0 && this.props.rollingAverage !== null &&
                                                    <div className="mt-2 text-info">
                                                        {T.translate('threshold.rollingAverage')} <strong>{this.props.rollingAverage} {this.props.unitOfMeasure ? `${this.props.unitOfMeasure}` : ''}</strong>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>}

                    {this.state.activeTab === '2' && <div className={"tab-pane " + (this.state.activeTab === '2' ? "active" : "")}>

                        {/*<DataGrid dataKey="accountTransactionID" usePaging downloadData csvFileName={'Thresholds ' + Date() + '.csv'} expandibleContent={false} pageSize="15" onHighlightStyle={this.setHighlightStyle}>*/}
                        {/*    {{*/}
                        {/*        rows: this.props.accountCommunications,*/}
                        {/*        columns: [*/}
                        {/*            { columnId: 'communicationDate', displayText: T.translate('threshold.date'), dataType: 'date', format: 'MM/dd/yyyy', bold: true, italic: true },*/}
                        {/*            { columnId: 'communicationTypeText', displayText: T.translate('threshold.category') },*/}
                        {/*            { columnId: 'recipient', displayText: T.translate('threshold.recipient') },*/}
                        {/*            { columnId: 'thresholdChannelName', displayText: T.translate('threshold.channel'), hightlightCell: true },*/}
                        {/*            { columnId: 'communicationText', displayText: T.translate('threshold.content'), style: { width: '50%' } }*/}
                        {/*        ]*/}
                        {/*    }}*/}
                        {/*</DataGrid>*/}

                    </div>}

                </div>


                <ConfirmModal
                    title={T.translate('threshold.updateThreshold')}
                    open={this.props.showUpdateAccountSuccessModal}
                    onToggle={this.props.toggleUpdateAccountSuccessModal}
                    loading={this.props.accountLoading}>
                    <div>
                        <p>{T.translate('threshold.thresholdsUpdated')}</p>
                        <p className="font-weight-bold">{T.translate('threshold.thresholdSuccessfullyUpdated')}</p>
                    </div>
                </ConfirmModal>

            </div>
        );
    }
}

export default connect(
    state => ({ ...state.account, ...state.common }),
    dispatch => bindActionCreators({ ...AccountStore.actionCreators, ...CommonStore.actionCreators }, dispatch)
)(Threshold);